/**
 * カンマ区切りの preference 文字列に対して、指定 webPath の有無をトグルする。
 *
 * @param currentPreferences 現在の preference 文字列（例: '' または 'instant-booking' または 'instant-booking,vegetarian-vegan-friendly'）
 * @param webPath トグルする preference の webPath（例: 'instant-booking'）
 * @returns トグル後のカンマ区切り文字列。空の場合は ''
 */
export function togglePreference(currentPreferences: string, webPath: string): string {
  const list = currentPreferences
    ? currentPreferences
        .split(',')
        .map((p) => p.trim())
        .filter(Boolean)
    : [];
  const newList = list.includes(webPath) ? list.filter((p) => p !== webPath) : [...list, webPath];
  return newList.join(',');
}
